import {Color} from 'components/design-guide/Action/Button/styles/colors';
import {SELECTOR_STYLES} from 'components/design-guide/Action/Button/styles/selector';
import {ButtonStateStyles} from 'components/design-guide/Action/Button/styles/types';
import {ButtonState} from 'components/design-guide/Action/Button/types';

const SELECTOR_TOGGLE_STYLE = new Map<ButtonState, ButtonStateStyles>([
  [
    'default',
    {
      fill: Color.SELECTOR_DEFAULT,
      text: Color.SELECTOR_DEFAULT_TEXT
    }
  ],
  [
    'hover',
    {
      border: Color.SECONDARY_DEFAULT_BORDER_AND_TEXT,
      borderWidth: '2.2px'
    }
  ]
]);

export const SELECTOR_TOGGLE_STYLES = new Map<ButtonState, ButtonStateStyles>([
  ...Array.from(SELECTOR_STYLES.entries()),
  ...Array.from(SELECTOR_TOGGLE_STYLE.entries())
]);
